import { deleteFieldCapacityOverride } from '@dispatch/shared/services';
import { useMutate } from '../api/useMutate';
import { useQueryClient } from 'react-query';

export const useDeleteFieldCapacityOverride = (
  responseFn: (data: { success: boolean }) => void | Promise<unknown>
) => {
  const queryClient = useQueryClient();
  const { mutate, error, status } = useMutate(
    ['delete-field-capacity-override'],
    (data: { resourceId: string; date: string }) =>
      deleteFieldCapacityOverride(data),
    (data) => {
      queryClient.invalidateQueries(['get-resource-field-capacity-overrides']);
      responseFn(data as { success: boolean });
    }
  );

  return {
    deleteFieldCapacityOverride: mutate,
    error,
    status,
  };
};
